export default __webpack_public_path__ + "static/family-773a875b31e6664660f1ac3ee79c26de.png";